import type { Disposable } from '@patsnap/tahiti-core';

/** 按钮操作引导所需的浏览器挂载能力。 */
export interface OnboardingActionGuideRuntime {
    /** 在目标元素内挂载引导手型。 */
    mountGuideHand(target: Element): Disposable;
    /** 为目标元素添加引导样式。 */
    addTargetClass(target: Element): void;
    /** 移除目标元素上的引导样式。 */
    removeTargetClass(target: Element): void;
}

/** 按钮操作引导运行时的容器标识。 */
export const OnboardingActionGuideRuntime = Symbol('OnboardingActionGuideRuntime');
